var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgTravel = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.9206 11.4746V9.92771C17.9206 8.86307 17.0607 8 16 8C14.9393 8 14.0794 8.86307 14.0794 9.92771V11.4746C14.0794 12.0426 13.7793 12.5679 13.291 12.8548L9.39559 15.143C8.69434 15.5549 8.98544 16.6326 9.79795 16.6326H13.4018C13.8417 16.6326 14.1984 16.9906 14.1984 17.4322V19.4123C14.1984 19.9405 14.0247 20.4539 13.7043 20.8728L12.2904 22.7216C12.0307 23.0612 12.0857 23.5462 12.4148 23.8185C12.6382 24.0034 12.9444 24.0511 13.2132 23.9428L15.3933 23.0451C15.7804 22.8857 16.2145 22.8856 16.6017 23.0447L18.7868 23.9428C19.0556 24.0511 19.3618 24.0034 19.5852 23.8185C19.9143 23.5462 19.9693 23.0612 19.7096 22.7216L18.2957 20.8728C17.9753 20.4539 17.8016 19.9405 17.8016 19.4123V17.4322C17.8016 16.9906 18.1583 16.6326 18.5982 16.6326H22.2021C23.0146 16.6326 23.3057 15.5549 22.6044 15.143L18.709 12.8548C18.2207 12.5679 17.9206 12.0426 17.9206 11.4746Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgTravel);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/travel.8b30f8f351a9a1e06804f3f72acd6858.svg";